<template>
    <div id="dashboard-stats">
        <div class="app-container mt-5">

            <div class="page-title gap-20 mb-3">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">query_stats</v-icon> Tableau de bord statistiques
                </span>
                <div style="width: 200px">
                    <v-select hide-details outlined item-text="label" :items="dashboards" v-model="selectedDashboard"
                        item-value="name" style="padding-top: 0!important;">
                    </v-select>
                </div>
            </div>

            <provider-stat v-if="selectedDashboard === 'PROVIDERS'"></provider-stat>
            <cmaj-stat v-if="selectedDashboard === 'CMAJS'"></cmaj-stat>
        </div>
    </div>
</template>

<script>
import ProviderStat from "./ProviderStat"
import CmajStat from "./CmajStat"

export default {
    name: "DasboardStat",
    components: { CmajStat, ProviderStat },
    data() {
        return {
            dashboards: [
                {
                    name: 'PROVIDERS',
                    label: 'Mes fiches'
                },
                {
                    name: 'CMAJS',
                    label: 'Mes campagnes'
                }
            ],
            selectedDashboard: null
        }
    },
    created() {
        this.selectedDashboard = this.dashboards[0].name
    }
}
</script>